<template>
  <div class="row">
    <form name="frmConversationMetadata" v-if="false" id="frmConversationMetadata">
      <div class="panel panel-primary">
        <div class="panel-heading padding-0">
          <h3 class="text-center panel-title">
            <a href="#content" data-toggle="collapse" class="collapsable-link-panel">
              Conversation Metadata
            </a>
          </h3>
        </div>
        <div id="content" class="panel-body collapse">
          <div class="row remove-style">
            <ConversationTheme 
              ref='currentTheme'
              :countryAndLanguages="countryAndLanguages"
              :conversationTheme="conversationTheme" 
            />
          </div>
          <div class="row remove-style">
            <CollapsibleMultiSelect
              ref='snomedCodeMultiSelect'
              :title="`Snomed Codes`"
              :optionList="snomedCodesList"
              :propOptions="conversationSnomedCodes"
              singleLeafNodeCheck="false"
            />
          </div>
          <div class="row remove-style">
            <CollapsibleMultiSelect
              ref='funnelStagesMultiSelect'
              :title="`Funnel Stages`"
              :optionList="funnelStagesList"
              :propOptions="conversationFunnelStagesList"
              singleLeafNodeCheck="true"
              singleLeafValidationError="A conversation can belong to only one stage of a funnel"
            />
          </div>
        </div>
      </div>
    </form>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>

  </div>
</template>

<script>
import api from '../../../utils/api'
import ConversationTheme from './conversationTheme'
import CollapsibleMultiSelect from './collapsibleMultiSelect'
export default {
  name: 'conversation-meta-data',
  props: ['metaData', 'countryAndLanguages'],
  components: {
    ConversationTheme,
    CollapsibleMultiSelect
  },
  data () {
    return {
      loading: false,
      isReferralApp: false,
      showMessageSetValidationError: false,
      funnelStagesList: [],
      snomedCodesList: [],
      conversationTheme: {},
      conversationSnomedCodes: [],
      conversationFunnelStagesList: []
    }
  },
  methods: {
    // The form is hidden (v-if) for now, so its fields may not exist: keep the saved values then.
    getConversationMetadata () {
      const { currentTheme, snomedCodeMultiSelect, funnelStagesMultiSelect } = this.$refs
      const saved = this.metaData || {}
      return {
        conv_theme: currentTheme ? currentTheme.getData() : saved.conv_theme,
        snomed_codes: snomedCodeMultiSelect ? snomedCodeMultiSelect.getData() : saved.snomed_codes,
        funnel_stages: funnelStagesMultiSelect ? funnelStagesMultiSelect.getData() : saved.funnel_stages
      }
    },
    getAllSnomedCodes () {
      // get all snomed codes from offerings
      return new Promise((resolve, reject) => {
        api.buildRequest('getSnomedCodes', 'GET')
          .then(response => {
            const { status, data } = response
            return status === 200 ? resolve(data.payload) : reject(false)
          }).catch((err) => {
            reject(err)
          })
      })
    },
    getFunnelStagesList () {
      // get all funnels and their stages from funnel stages in postgres
      return new Promise((resolve, reject) => {
        api.buildRequest('getFunnelStagesList', 'GET')
          .then(response => {
            const { status, data } = response
            return status === 200 ? resolve(data.payload) : reject(false)
          }).catch((err) => {
            reject(err)
          })
      })
    },
    formatFunnelsData (funnels) {
      const funnelsMap = new Map()
      for (let stage of funnels) {
        const funnelId = stage.funnel_id
        if (funnelsMap.has(funnelId)) {
          const funnelStages = funnelsMap.get(funnelId)
          funnelStages.push(stage)
          funnelsMap.set(funnelId, funnelStages)
        } else {
          const stageArr = new Array(stage)
          funnelsMap.set(funnelId, stageArr)
        }
      }

      const funnelTree = []
      for (const [funnelId, stages] of funnelsMap) {
        const funnelStages = []
        for (let stage of stages) {
          funnelStages.push({
            id: `${funnelId} - ${stage.short_name}`,
            label: stage.stage_name,
            country: stage.country.toUpperCase(),
            legacy_name: stage.funnel_name
          })
        }
        funnelTree.push({
          id: funnelId,
          label: `${stages[0].country.toUpperCase()} - ${stages[0].funnel_name}`,
          children: funnelStages
        })
      }

      return funnelTree
    },
    async getData () {
      try {
        const snomedCodes = await this.getAllSnomedCodes()
        this.snomedCodesList = snomedCodes.map(ele => { return {id: ele.short_name, label: `${ele.legacy_name} (${ele.snomed_code})`, legacy_name: ele.legacy_name} })
        const funnels = await this.getFunnelStagesList()
        this.funnelStagesList = this.formatFunnelsData(funnels)
      } catch (error) {
        console.log(error)
      }
    },
    parseMetadata (metaData) {
      const stageList = []
      for (let funnel of this.funnelStagesList) stageList.push(...funnel.children)
      this.conversationFunnelStagesList = stageList.filter(ele => metaData.funnel_stages.includes(ele.id.split('-')[1].trim())).map(ele => ele.id)
      this.conversationSnomedCodes = metaData.snomed_codes
      this.conversationTheme = metaData.conv_theme
    }
  },
  async mounted () {
    await this.getData()
    this.parseMetadata(this.metaData)
  },
  watch: {
    metaData: function (value) {
      this.parseMetadata(value)
    }
  }
}
</script>
<style>
.panel {
  margin-bottom: 10px; 
}
h3 a:hover, h3 a:active, h3 a:focus {
    outline: none;
    border: 0;
    color: white;
}
.remove-style {
  margin: 0px;
}
.padding-0 {
  padding: 0px;
}
.collapsable-link-panel {
  display: block;
  padding: 10px;
}
.collapsable-link-panel-child {
  background: #0D9488;
}
</style>



// WEBPACK FOOTER //
// conversationMetadata.vue?33533a9e